
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const Botox = () => {
  const packages = [
    {
      name: "MiniTox (10 units)",
      visitorPrice: "$149",
      memberPrice: "$99",
      description: "Perfect for forehead touch-ups and brow lifts"
    },
    {
      name: "GlowTox (20 units)",
      visitorPrice: "$299",
      memberPrice: "$199",
      description: "Full forehead, frown lines, and crow's feet"
    },
    {
      name: "Add Lip Flip",
      visitorPrice: "+$50",
      memberPrice: "+$25",
      description: "Subtle lip enhancement with your treatment"
    }
  ];

  const whoItsFor = [
    "Expression lines and wrinkles",
    "Forehead furrows",
    "Crow's feet",
    "Frown lines",
    "Brow lifting",
    "Preventative anti-aging"
  ];

  const beforeCare = [
    "Avoid alcohol 24 hours prior",
    "Stop blood thinners if cleared by doctor",
    "Stay hydrated",
    "Arrive with clean skin"
  ];

  const duringCare = [
    "Quick 10-15 minute session",
    "Minimal discomfort",
    "Topical numbing available",
    "Immediate return to activities"
  ];

  const afterCare = [
    "No exercise for 24 hours",
    "Stay upright for 4 hours",
    "Results visible in 3-14 days",
    "Avoid touching treated areas"
  ];

  const memberPerks = [
    "Save 20-30% on every treatment",
    "Receive bonus units with packages",
    "Priority booking and scheduling",
    "Free touch-ups within 2 weeks",
    "Birthday treatment discounts",
    "Access to member-only events"
  ];

  return (
    <TreatmentPageTemplate
      title="Botox"
      subtitle="Smooth. Subtle. Elevated."
      description="Botox is a wrinkle-relaxing injectable that softens expression lines while preserving your natural look. Our expert injectors create results that look refreshed, never frozen."
      whoItsFor={whoItsFor}
      packages={packages}
      beforeCare={beforeCare}
      duringCare={duringCare}
      afterCare={afterCare}
      memberPerks={memberPerks}
    />
  );
};

export default Botox;
